// component
import { Helmet } from "react-helmet-async";
import { Navbar1 } from '../../../components/navbars';
import { Hero9 } from '../../../components/heros';
import BackToTop from '../../../components/BackToTop';
import { Footer1 } from '../../../components/footer';

import About from './About';
import Feature from './Feature';
import Counter from './Counter';
import Team from './Team';
import Client from './Client';
import { benefits } from './data';

// dummy data
import { teamMembers } from './data';
import Benefits from './Benefits';
import HeroAbout from './HeroAbout';

const Company = () => {
    return (
        <>
            {/* <div id="about"> */}


            {/* <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <meta name="description" content="Learn more about Sales Trackify, our mission, and our team." />
                    <meta name="keywords" content="About Sales Trackify, Our Team, Business Growth" />
                    <meta name="author" content="Sales Trackify Team"></meta>
                    <title>About Us - Learn more about Sales Trackify, our mission, and our team.</title>
                </Helmet> */}
            {/* header and hero */}
            <div className='header-7 '>
                {/* <HeroAbout /> */}
            </div>


            <About />


            {/* <Feature /> */}

            <Benefits benefits={benefits} />


            {/* <Footer1 /> */}

            <BackToTop variant="info" />
            {/* </div> */}
        </>
    );
};

export default Company;
